import { render, staticRenderFns } from "./DashboardCdxe.vue?vue&type=template&id=10aaebb7&scoped=true"
import script from "./DashboardCdxe.vue?vue&type=script&lang=js"
export * from "./DashboardCdxe.vue?vue&type=script&lang=js"
import style0 from "./DashboardCdxe.vue?vue&type=style&index=0&id=10aaebb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aaebb7",
  null
  
)

export default component.exports